<div class="relative" *transloco="let t; read: 'home'">
  <div class="w-full flex justify-center"
       [ngClass]="{'blur-sm pointer-events-none': [UserRole.ROLE_BUSINESS_EXP, UserRole.ROLE_BUSINESS_PLUS_EXP] | userHasRole}">
    <div #calculatorTop class="scroll-m-[80px]"></div>
    <div class="w-[95%] flex flex-col items-stretch pb-10"
         [ngClass]="{'hidden': !!calculationResultWrapper}">
      <psc-section-title
        [lineWidthPercentage]="25"
        class="self-center"
        [title]="t('calculator.advanced_title')"></psc-section-title>
      <psc-calculator
        [source]="source"
        (resultCalculated)="onCalculationEnded($event)"
        [advanced]="true"
      ></psc-calculator>
    </div>

    <div class="w-full flex pt-8 justify-center bg-gray-100 pb-10 px-4 min-h-screen"
         *ngIf="calculationResultWrapper" @inOutAnimation>
      <div
        class="flex flex-col items-center justify-center relative w-full lg:w-9/12 mx-auto bg-white shadow-lg p-4 md:p-10 rounded-2xl">
        <div *ngIf="plantNeedsPayment"
             class="absolute top-10 left-1/2 transform -translate-x-1/2  z-20 blur-none pointer-events-auto">
          <psc-pay-for-full
            [paymentType]="PaymentType.EnterpriseAnalysis"
            [userId]="calculationResultWrapper.result.userId"
            [analysisId]="calculationResultWrapper.result.analysisId"></psc-pay-for-full>
        </div>
        <psc-result-title
          [ngClass]="{'blur-sm pointer-events-none': plantNeedsPayment}"
          [title]="t('calculator.result_title')"
          [calculationResultWrapper]="calculationResultWrapper"
          class="w-full">
        </psc-result-title>
        <psc-advanced-solar-calculation-result
          [ngClass]="{'blur-sm pointer-events-none': plantNeedsPayment}"
          class="w-full"
          (recalculated)="recalculate($event)"
          [solarCalculatorResultWrapper]="calculationResultWrapper"></psc-advanced-solar-calculation-result>

        <ng-container *transloco="let g; read 'home.calculator.map'">
          <psc-button
            class="mt-6"
            type="secondary-blue"
            @inOutAnimation
            (buttonClicked)="startFromBeginning()"
            [label]="g('start_from_beginning')">
          </psc-button>
        </ng-container>
      </div>
    </div>
  </div>
  <ng-container
    *transloco="let g; read: 'expired_sub'">
    <ng-container *ngIf="[UserRole.ROLE_BUSINESS_EXP, UserRole.ROLE_BUSINESS_PLUS_EXP] | userHasRole">
      <div
        class="flex flex-col items-center gap-5 absolute top-10 bg-white bg-opacity-90 shadow-2xl rounded-xl p-8 text-blue1"
        @inOutAnimation>
        <psc-section-title
          [title]="g('title')"
          [subtitle]="g('advanced_subtitle')"
        ></psc-section-title>
        <a
          routerLink="/user/profile"
          [queryParams]="{tab: 'Subscription'}">
          <psc-button
            [label]="g('renew')"></psc-button>
        </a>
      </div>
    </ng-container>
  </ng-container>
</div>
